"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCONNECT_ERROR_CODES = exports.SIGN_DATA_ERROR_CODES = void 0;
var sign_data_rpc_response_1 = require("./sign-data-rpc-response");
Object.defineProperty(exports, "SIGN_DATA_ERROR_CODES", { enumerable: true, get: function () { return sign_data_rpc_response_1.SIGN_DATA_ERROR_CODES; } });
var disconnect_rpc_response_1 = require("./disconnect-rpc-response");
Object.defineProperty(exports, "DISCONNECT_ERROR_CODES", { enumerable: true, get: function () { return disconnect_rpc_response_1.DISCONNECT_ERROR_CODES; } });
